module.exports = __webpack_public_path__ + "static/media/privacidad.4d753763.pdf";